import React, { createContext, useContext, useEffect, useState } from 'react';
import { displayLoader, clearLoader } from "../reducers/genericLoader";
import { RegionContext, RegionsState } from './RegionProvider';
import { useDispatch } from 'react-redux';
import { getPhysicianById } from '../services/physicianServices';
import { notifcationError } from '../reducers/notificationReducer';
import { withTranslation } from 'react-i18next';

export interface PhysicianDataState {
  isLoading: boolean
  isError: boolean
  error: any
  profileData: any;
  regionProps?: RegionsState
}

export const initialState: PhysicianDataState = {
  isLoading: false,
  isError: false,
  error: null,
  regionProps: {} as any,
  profileData: {}
};

export const PhysicianDataContext = createContext(initialState);

const PhysicianDataProvider = (props): any => {
  const [currentState, setCurrentState] = useState(initialState);
  const dispatch = useDispatch();
  const { physicianId, t } = props;
  const regionContext = useContext(RegionContext);

  useEffect(() => {
    const physicianData = async () => {
      try {
        dispatch(displayLoader(t('loader.loadingInitialData')));

        setCurrentState({
          ...initialState,
          isLoading: true
        });

        const doctorData = await getPhysicianById(physicianId),
          {
            countyId,
            cityId
          } = doctorData;

        if (!countyId || !cityId) {
          dispatch(notifcationError(t('loader.dataLoadError')));

          return;
        }

        await (regionContext as any).getCountiesAndCity(countyId, countyId, cityId);

        setCurrentState({
          isLoading: false,
          isError: false,
          error: undefined,
          profileData: doctorData,
          regionProps: regionContext,
        });
      } catch (exc) {
        dispatch(notifcationError(t('loader.dataLoadError')));

        setCurrentState({
          ...initialState,
          error: exc,
          isError: true
        });
      } finally {
        dispatch(clearLoader());
      }
    }

    physicianData();
  }, [physicianId]);

  return (
    <PhysicianDataContext.Provider value={{
      ...currentState
    }}>
      {props.children}
    </PhysicianDataContext.Provider>
  )
}

export default withTranslation()(PhysicianDataProvider);
